import React, { Component } from 'react';
import { Row, Col, Radio, Table, Button, Modal, Form, InputNumber, Input, Cascader, Select, Upload, Icon, message } from 'antd';
import { api, app, config } from "../../app";
import Loading from "../../components/Loading";
import utils from "../../utils";
import MMGoodEditBox from './MMGoodEditBox';
import underscore from "underscore";

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const FormItem = Form.Item;
const { Option } = Select;

function formItemLayout(num = 16) {
    return {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 6 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: num },
        }
    };
}

class MMGoods extends Component {
    constructor(props) {
        super(props);
        this.state = {
            classList: [],
            classList2: [],
            goodList: [],
            fileList: [],
            fileList2: [],
            edit_good: {},
            page: 1,
            total: 0,
            class_loading: true,
            is_audit2: 10,
            is_team2: 10,
            ifuse2: 1,
            previewImage: '',
            previewImage2: '',
            previewVisible: false,
            previewVisible2: false,
        };
    }

    setData = async (data) => {
        await app.setStateSync(this, data);
    }

    async componentDidMount() {
        this._isMounted = true;
        await this.ClassList();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }


    /**
     * 分类集合
     * @returns {Promise<any>}
     * @constructor
     */
    ClassList = () => {
        const _this = this, params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            type: 1,
        };
        app.post(api.MallClassListing, params).then(({ flag, data, msg }) => {
            if (_this._isMounted) {
                if (flag === 1) {
                    const classList2 = data.map((cla) => {
                        return {
                            label: cla.class_name,
                            value: cla.id,
                            children: (cla.subclass || []).map((sub) => {
                                return {
                                    label: sub.class_name,
                                    value: sub.id,
                                    children: (sub.subclass || []).map((sub1) => {
                                        return {
                                            label: sub1.class_name,
                                            value: sub1.id
                                        }
                                    })
                                }
                            })
                        };
                    });
                    _this.setState({ classList2, classList: data, class_id: data[0].id }, () => {
                        _this.goodSource(1);
                    });
                } else {
                    app.alert(msg, 'warn');
                }
                _this.setState({ class_loading: false });
            }
        })
    }

    /**
     * 商品数据
     * @param page
     */
    goodSource = async (page) => {
        await this.setData({ page, data_loading: true });
        let params = {
            page,
            class_id: this.state.class_id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            ifuse: this.state.ifuse2,
            is_audit: this.state.is_audit2,
            is_team: this.state.is_team2,
        };
        let { flag, data, msg, total = 0 } = await app.post(api.AdminMallListing, params);
        if (flag !== 1) {
            app.alert(msg, 'warn');
            data = [];
        }
        let state = { goodList: utils.addArrayKey(data), total: parseInt(total) };
        if (this.state.page === page) {
            state.data_loading = false;
        }
        await this.setData(state);
    }

    /**
     * 选择分类
     * @param e
     */
    handleSelectType = (e) => {
        console.log(e);
        this.setState({ class_id: e.target.value, total: 0 }, () => {
            this.goodSource(1);
        });
    }

    /**
     * 关闭编辑框
     */
    handleCloseEdit = () => {
        this.setState({ edit_visible: false, submit_loading: false });
    }

    /**
     * 打开编辑框
     */
    handleOpenEdit = (edit_good) => {

        let { classList } = this.state, fileList = [{
            uid: -1,
            name: '',
            status: 'done',
            url: config.imgUrl + edit_good.localpath,
            response: {
                flag: 1,
                data: { url: edit_good.localpath }
            }
        }];
        let class_id = ['', '', ''];
        let mall_class = edit_good.mall_class;
        let ok = false;
        for (let i1 = 0; i1 < classList.length; i1++) {
            if (ok) break;
            let c1 = classList[i1];
            if (c1.id === mall_class) {
                class_id[0] = c1.id;
            } else {
                for (let i2 = 0; i2 < (c1.subclass || []).length; i2++) {
                    if (ok) break;
                    let c2 = c1.subclass[i2];
                    if (c2.id === mall_class) {
                        class_id[0] = c1.id;
                        class_id[1] = c2.id;
                        ok = true;
                        break;
                    } else {
                        for (let i3 = 0; i3 < (c2.subclass || []).length; i3++) {
                            let c3 = c2.subclass[i3];
                            if (c3.id === mall_class) {
                                class_id[0] = c1.id;
                                class_id[1] = c2.id;
                                class_id[2] = c3.id;
                                ok = true;
                                break;
                            }
                        }
                    }
                }
            }
        }
        edit_good.class_id = class_id;
        edit_good.fileList = fileList;
        edit_good.manufacturer_img = fileList;
        // app.alert("该功能正在火速开发中，敬请期待")
        this.setState({ edit_good, fileList, edit_visible: true });
    }

    /**
     * 商品图片展示
     * @param file
     */
    handlePreview = (file) => {
        this.setState({
            previewImage: file.url || file.thumbUrl,
            previewVisible: true,
        });
    }

    /**
     * 商品描述图片展示
     * @param file
     */
    handlePreview2 = (file) => {
        this.setState({
            previewImage2: file.url || file.thumbUrl,
            previewVisible2: true,
        });
    }

    handleChange = ({ file, fileList }) => {
        this.setState({ fileList }, () => {
            if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/gif' && file.type !== 'image/jpg') {
                this.setState({ fileList: [] });
            } else if (file.status === 'done') {
                if (file.response.flag === 1) {
                    this.setState({ fileList });
                    console.log('上传成功');
                } else {
                    app.alert(file.response.msg, 'warn');
                    this.setState({ fileList: [] });
                }
            }
        });
    }

    handleChange2 = ({ file, fileList2 }) => {
        this.setState({ fileList2 }, () => {
            if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/gif' && file.type !== 'image/jpg') {
                this.setState({ fileList2: [] });
            } else if (file.status === 'done') {
                if (file.response.flag === 1) {
                    this.setState({ fileList2 });
                    console.log('上传成功');
                } else {
                    app.alert(file.response.msg, 'warn');
                    this.setState({ fileList2: [] });
                }
            }
        });
    }

    handleCancel = () => this.setState({ previewVisible: false })
    handleCancel2 = () => this.setState({ previewVisible2: false })

    /**
     * 提交
     * @param e
     */
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                if (this.state.submit_loading) return false;
                this.setState({ submit_loading: true }, () => {
                    const _this = this, params = {
                        indexno: app.getData('indexno'),
                        account: app.getData('account'),
                    };
                    values.class_id = values.class_id[values.class_id.length - 1];
                    // values.images = this.state.fileList[0].response.data.url;
                    values.images = this.state.fileList.response.data.url;
                    values.manufacturer_img = this.state.fileList2.response.data.url;
                    values = Object.assign(params, values);
                    app.post(api.AdminMallEdit, values).then(({ flag, data, msg }) => {
                        if (_this._isMounted) {
                            if (flag === 1) {
                                app.alert("修改成功", "success");
                                _this.props.form.resetFields();
                                _this.setState({ fileList: [], total: 0 }, () => {
                                    _this.goodSource(_this.state.page);
                                    _this.handleCloseEdit();
                                });
                            } else {
                                app.alert(msg, 'warn');
                            }
                        }
                    })
                });
            }
        });
    }

    /**
     * 商品图片上传前
     * @param file
     * @param fileList
     * @returns {boolean}
     */
    handleBeforeUpload = (file) => {
        if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/gif') {
            return true;
        }
        app.alert('请上传jpg,jpeg,png,gif格式的图片', 'warn');
        this.setState({ fileList: [] });
        return false;
    }

    /**
     * 商品描述图片上传前
     * @param file
     * @param fileList
     * @returns {boolean}
     */
    handleBeforeUpload2 = (file) => {
        if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/gif') {
            return true;
        }
        app.alert('请上传jpg,jpeg,png,gif格式的图片', 'warn');
        this.setState({ fileList2: [] });
        return false;
    }

    getSearch1 = async (e) => {
        let a = '';
        if (e == undefined || e == '') {
            a = 10;
        } else {
            a = e;
        }
        await this.setData({
            ifuse2: a,
        });
        setTimeout(() => {
            this.goodSource(1);
        }, 500);
    }

    getSearch2 = async (e) => {
        let a = '';
        if (e == undefined || e == '') {
            a = 10;
        } else {
            a = e;
        }
        await this.setData({
            is_audit2: a,
        });
        setTimeout(() => {
            this.goodSource(1);
        }, 500);
    }

    getSearch3 = async (e) => {
        let a = '';
        if (e == undefined || e == '') {
            a = 10;
        } else {
            a = e;
        }
        await this.setData({
            is_team2: a,
        });
        setTimeout(() => {
            this.goodSource(1);
        }, 500);
    }

    handleModalSubmit = async (e) => {
        console.log(e);
        await this.setData({
            edit_visible: e,
        })
    }

    // 打开发布商品接口
    openAddGood() {
        this.setData({
            edit_visible: true,
            edit_good: {
                id: '',
            }
        })
    }

    render() {
        let columns = [
            {
                title: '商品ID',
                dataIndex: 'id',
                key: 'id',
                width: '5%'
            },
            {
                title: '商品名称',
                dataIndex: 'ppename',
                key: 'ppename',
                width: '30%'
            },
            {
                title: '分类',
                dataIndex: 'class_name',
                key: 'class_name',
                width: 100,
            },
            {
                title: '售价',
                dataIndex: 'ppeprice',
                key: 'ppeprice',
                width: 100,
                render(text) {
                    return <span style={{ textAlign: 'center' }}>{text}</span>;
                }
            },
            {
                title: '是否审核',
                dataIndex: 'is_audit',
                key: 'is_audit',
                width: 100,
                render(text) {
                    if (text === '0') {
                        return <span>否</span>;
                    } else {
                        return <span>是</span>;
                    }
                }
            },
            {
                title: '是否发货队部',
                dataIndex: 'is_team',
                key: 'is_team',
                width: 150,
                render(text) {
                    if (text == '0') {
                        return <span>否</span>;
                    } else {
                        return <span>是</span>;
                    }
                }
            },
            {
                title: '状态',
                dataIndex: 'ifuse',
                key: 'ifuse',
                width: 60,
                render(text) {
                    if (text === 'true') {
                        return <span>上架</span>;
                    } else {
                        return <span>下架</span>;
                    }
                }
            },
            {
                title: '操作',
                dataIndex: '',
                key: 'cz',
                width: 60,
                render: (text, record, index) => {
                    return (
                        <Button size="small" type="primary" onClick={() => this.handleOpenEdit(record)}>编辑</Button>
                    )
                }
            },
        ],
            { getFieldDecorator, getFieldValue } = this.props.form,
            { class_loading, classList, classList2, data_loading, submit_loading, goodList, total, page, class_id, edit_good, edit_visible, fileList, fileList2, previewImage2, previewVisible2, previewVisible, previewImage } = this.state,
            locale = {
                emptyText: data_loading ? '正在加载中...' : '此类型暂无商品',
            },
            uploadButton = (
                <div>
                    <Icon type="plus" />
                    <div className="ant-upload-text">上传照片</div>
                </div>
            );
        return (
            <div>
                {
                    edit_visible ?
                        <Row className="good-list">
                            <MMGoodEditBox info={edit_good} callBackFun={(e) => this.handleModalSubmit(e)} />
                        </Row>
                        :
                        <Row className="mall-manage-goods" style={{height: '800px'}}>

                            <Col span={3} className="type-list">
                                <p className="type-title">类型</p>
                                {class_loading ? <Loading /> :
                                    <RadioGroup style={{ width: '100%' }} onChange={this.handleSelectType} className="list" defaultValue={class_id}>
                                        {
                                            classList.length > 0 ?
                                                classList.map((team, index) => {
                                                    return (
                                                        <RadioButton key={index} className='type' value={team.id}>
                                                            <div title={team.class_name}>{team.class_name}</div>
                                                        </RadioButton>
                                                    )
                                                }) : (<p style={{ textAlign: "center", padding: "20px 0" }}>无对应队伍</p>)
                                        }
                                    </RadioGroup>
                                }
                            </Col>

                            <Col span={20} offset={1} className="good-list">

                                <div style={{ marginBottom: '16px' }}>
                                    <Form layout="inline">
                                        <Form.Item label="商品状态">
                                            {getFieldDecorator('ifuse2', { initialValue: '上架' })(
                                                <Select onChange={(e) => this.getSearch1(e)} placeholder="全部" style={{ width: '120px' }} allowClear>
                                                    <Option value="10">全部</Option>
                                                    <Option value="1">上架</Option>
                                                    <Option value="0">下架</Option>
                                                </Select>
                                            )}
                                        </Form.Item>
                                        <Form.Item label="是否审核">
                                            {getFieldDecorator('is_audit2', { initialValue: '全部' })(
                                                <Select onChange={(e) => this.getSearch2(e)} placeholder="全部" style={{ width: '120px' }} allowClear>
                                                    <Option value="10">全部</Option>
                                                    <Option value="1">是</Option>
                                                    <Option value="0">否</Option>
                                                </Select>
                                            )}
                                        </Form.Item>
                                        <Form.Item label="是否发往队部">
                                            {getFieldDecorator('is_team2', { initialValue: '全部' })(
                                                <Select onChange={(e) => this.getSearch3(e)} placeholder="全部" style={{ width: '120px' }} allowClear>
                                                    <Option value="10">全部</Option>
                                                    <Option value="1">是</Option>
                                                    <Option value="0">否</Option>
                                                </Select>
                                            )}
                                        </Form.Item>
                                        {/* <Form.Item>
                                            <Button type='primary' onClick={()=>this.openAddGood()}>发布商品</Button>
                                        </Form.Item> */}
                                    </Form>
                                </div>
                                <Table columns={columns}
                                    locale={locale}
                                    dataSource={goodList}
                                    scroll={{ y: 'calc(100% - 38px)' }}
                                    pagination={{
                                        total,
                                        pageSize: 20,
                                        current: page,
                                        showTotal: (total) => `总数量：${total}`,
                                        onChange: (page) => {
                                            this.goodSource(page);
                                        }
                                    }}
                                    size="small"
                                    loading={data_loading}
                                />

                            </Col>


                            <Modal
                                visible={false}
                                // visible={edit_visible}
                                onCancel={this.handleCloseEdit}
                                onOk={this.handleSubmit}
                                footer={
                                    <div style={{ textAlign: 'center' }}>
                                        <Button onClick={this.handleCloseEdit}>取消</Button>
                                        <Button type="primary" onClick={this.handleSubmit} loading={submit_loading}>提交修改</Button>
                                    </div>
                                }
                                maskClosable={false}
                                style={{ top: 20 }}
                                bodyStyle={{ height: 800, overflowX: 'auto', }}
                                width={1000}
                                className="mall-manage-good-edit-modal"
                            >
                                <Form onSubmit={this.handleSubmit}>

                                    {getFieldDecorator('mall_id', { initialValue: edit_good.id })(
                                        <Input type="hidden" />
                                    )}

                                    <FormItem
                                        {...formItemLayout(10)}
                                        label="商品分类"
                                    >
                                        {getFieldDecorator('class_id', {
                                            rules: [{
                                                required: true, message: '请选择商品分类'
                                            }], initialValue: edit_good.class_id
                                        })(
                                            <Cascader notFoundContent="暂无商品分类"
                                                options={classList2}
                                                placeholder="请选择商品分类"
                                                expandTrigger='hover'
                                                changeOnSelect={true}
                                            />
                                        )}
                                    </FormItem>

                                    <FormItem
                                        label="商品图片(首张为封面图)"
                                        {...formItemLayout()}
                                    >
                                        {getFieldDecorator('images', {
                                            rules: [{ required: true, message: '请上传商品图片' }],
                                            initialValue: edit_good.fileList
                                        })(
                                            <Upload
                                                action={config.serverUrl + api.ImageUpload}
                                                data={{
                                                    indexno: app.getData('indexno'),
                                                    account: app.getData('account'),
                                                    token: app.getData('token'),
                                                    upload_type: 'mall',
                                                }}
                                                name="image"
                                                fileList={fileList}
                                                listType="picture-card"
                                                accept="image/gif, image/jpeg, image/jpg, image/png"
                                                onPreview={this.handlePreview}
                                                onChange={this.handleChange}
                                                beforeUpload={this.handleBeforeUpload}
                                            >
                                                {fileList.length > 0 ? null : uploadButton}
                                            </Upload>
                                        )}
                                    </FormItem>

                                    <FormItem
                                        {...formItemLayout()}
                                        label="商品名称"
                                    >
                                        {getFieldDecorator('name', {
                                            rules: [{
                                                required: true, message: '请输入商品名称'
                                            }], initialValue: edit_good.ppename
                                        })(
                                            <Input placeholder="请输入商品名称" />
                                        )}
                                    </FormItem>

                                    <FormItem
                                        {...formItemLayout()}
                                        label="商品描述(文字)"
                                    >
                                        {getFieldDecorator('remark', {
                                            rules: [{
                                                required: true, message: '请输入商品描述'
                                            }], initialValue: edit_good.ppedetail
                                        })(
                                            <Input.TextArea placeholder="请输入商品描述" autosize={{ minRows: 2, maxRows: 4 }} />
                                        )}
                                    </FormItem>

                                    <FormItem
                                        label="商品描述(图片)"
                                        {...formItemLayout()}
                                    >
                                        {getFieldDecorator('manufacturer_img', {
                                            rules: [{ required: true, message: '请上传商品描述图片' }],
                                            initialValue: edit_good.manufacturer_img
                                        })(
                                            <Upload
                                                action={config.serverUrl + api.ImageUpload}
                                                data={{
                                                    indexno: app.getData('indexno'),
                                                    account: app.getData('account'),
                                                    token: app.getData('token'),
                                                    upload_type: 'mall',
                                                }}
                                                name="image"
                                                fileList2={fileList2}
                                                listType="picture-card"
                                                accept="image/gif, image/jpeg, image/jpg, image/png"
                                                onPreview={this.handlePreview2}
                                                onChange={() => this.handleChange2}
                                                beforeUpload={this.handleBeforeUpload2}
                                            >
                                                {fileList2.length > 0 ? null : uploadButton}
                                            </Upload>
                                        )}
                                    </FormItem>

                                    <FormItem
                                        {...formItemLayout()}
                                        label="店家提示"
                                    >
                                        {getFieldDecorator('statement', {
                                            rules: [{
                                                required: false, message: '请输入店家提示'
                                            }], initialValue: edit_good.ppedetail
                                        })(
                                            <Input.TextArea placeholder="请输入店家提示" autosize={{ minRows: 2, maxRows: 4 }} />
                                        )}
                                    </FormItem>

                                    {/* <FormItem
                                {...formItemLayout(10)}
                                label="商品状态"
                            >
                                {getFieldDecorator('status', {
                                    rules: [{
                                        required: true, message: '请选择商品状态'
                                    }], initialValue: edit_good.ifuse === 'true' ? '1' : '0'
                                })(
                                    <Select placeholder="请选择商品状态">
                                        <Option value="1">上架</Option>
                                        <Option value="0">下架</Option>
                                    </Select>
                                )}
                            </FormItem> */}

                                    <FormItem
                                        {...formItemLayout(8)}
                                        label="商品售价(元)"
                                    >
                                        {getFieldDecorator('price', {
                                            rules: [{
                                                required: true, message: '请输入商品售价'
                                            }], initialValue: edit_good.ppeprice
                                        })(
                                            <InputNumber precision={2} style={{ width: '100%' }} placeholder="请输入商品售价" />
                                        )}
                                    </FormItem>

                                    <div>
                                        <div
                                            style={{
                                                position: 'relative',
                                                top: '30px',
                                                color: 'red',
                                                left: 'calc(24% - 70px)'
                                            }}
                                        >*</div>
                                        <FormItem
                                            {...formItemLayout(4)}
                                            label="商品规格"
                                        >
                                            {getFieldDecorator('spec', {
                                                rules: [{
                                                    required: false, message: '请新增规格'
                                                }],
                                            })(
                                                <Button onClick={() => this.openSpecBox()} style={{ width: '100%' }}>+ 新增规格</Button>
                                            )}
                                        </FormItem>
                                    </div>

                                    <FormItem
                                        {...formItemLayout(8)}
                                        label="商品重量(kg)"
                                    >
                                        {getFieldDecorator('weight', {
                                            rules: [{
                                                required: true, message: '请输入商品重量'
                                            }], initialValue: edit_good.weight || 0
                                        })(
                                            <InputNumber style={{ width: '100%' }} placeholder="请输入商品重量" />
                                        )}
                                    </FormItem>

                                    <FormItem
                                        {...formItemLayout(8)}
                                        label="生产数量"
                                    >
                                        {getFieldDecorator('produce_number', {
                                            rules: [{
                                                required: true, message: '请输入生产数量'
                                            }], initialValue: edit_good.produce_number || 0
                                        })(
                                            <InputNumber style={{ width: '100%' }} placeholder="请输入生产数量" />
                                        )}
                                    </FormItem>

                                    <FormItem
                                        {...formItemLayout(8)}
                                        label="是否审核"
                                    >
                                        {getFieldDecorator('is_audit', {
                                            rules: [{
                                                required: true, message: '请选择是否审核'
                                            }], initialValue: edit_good.is_audit || null
                                        })(
                                            <RadioGroup placeholder="请选择是否审核">
                                                <Radio value="1">是</Radio>
                                                <Radio value="0">否</Radio>
                                            </RadioGroup>
                                        )}
                                    </FormItem>

                                    <FormItem
                                        {...formItemLayout(8)}
                                        label="是否限购"
                                    >
                                        {getFieldDecorator('is_astrict', {
                                            rules: [{
                                                required: true, message: '请选择是否限购'
                                            }], initialValue: edit_good.is_astrict || '0'
                                        })(
                                            <RadioGroup placeholder="请选择是否限购">
                                                <Radio value="1">是</Radio>
                                                <Radio value="0">否</Radio>
                                            </RadioGroup>
                                        )}
                                    </FormItem>
                                    {
                                        getFieldValue('is_astrict') === '1' ? (
                                            <div>
                                                <FormItem
                                                    {...formItemLayout(8)}
                                                    label="限购次数"
                                                >
                                                    {getFieldDecorator('astrict_how', {
                                                        rules: [
                                                            { required: true, message: '请输入限购次数' },
                                                            { type: 'integer', min: 1, message: '最少一件' },
                                                        ], initialValue: parseInt(edit_good.astrict_how || 0) || null
                                                    })(
                                                        <InputNumber style={{ width: '100%' }} placeholder="请输入限购次数" />
                                                    )}
                                                </FormItem>
                                                <FormItem
                                                    {...formItemLayout(8)}
                                                    label="限购数量"
                                                >
                                                    {getFieldDecorator('astrict_number', {
                                                        rules: [
                                                            { required: true, message: '请输入限购数量' },
                                                            { type: 'integer', min: 1, message: '最少一件' },
                                                        ], initialValue: parseInt(edit_good.astrict_number || 0) || null
                                                    })(
                                                        <InputNumber style={{ width: '100%' }} placeholder="请输入限购数量" />
                                                    )}
                                                </FormItem>
                                            </div>
                                        ) : null
                                    }

                                    <FormItem
                                        {...formItemLayout(8)}
                                        label="是否发货队部"
                                    >
                                        {getFieldDecorator('is_team', {
                                            rules: [{
                                                required: true, message: '请选择是否发货队部'
                                            }], initialValue: edit_good.is_audit || null
                                        })(
                                            <RadioGroup placeholder="请选择是否发货队部">
                                                <Radio value="1">是</Radio>
                                                <Radio value="0">否</Radio>
                                            </RadioGroup>
                                        )}
                                    </FormItem>

                                    <FormItem
                                        {...formItemLayout(8)}
                                        label="商品状态"
                                    >
                                        {getFieldDecorator('status', {
                                            rules: [{
                                                required: true, message: '请选择商品状态'
                                            }], initialValue: edit_good.is_audit || null
                                        })(
                                            <RadioGroup placeholder="请选择商品状态">
                                                <Radio value="1">上架</Radio>
                                                <Radio value="0">下架</Radio>
                                            </RadioGroup>
                                        )}
                                    </FormItem>

                                </Form>
                            </Modal>
                            <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                                <img alt="example" style={{ width: '100%' }} src={previewImage} />
                            </Modal>
                            <Modal visible={previewVisible2} footer={null} onCancel={this.handleCancel2}>
                                <img alt="example" style={{ width: '100%' }} src={previewImage2} />
                            </Modal>
                        </Row>
                }
            </div>
        );
    }
}

export default Form.create()(MMGoods);



// WEBPACK FOOTER //
// ./src/routes/mall_manage/MMGoods.jsx